export default {
  'footer.copyright':
    '© 2025 GMPD Culture Promotion Association. All rights reserved.',
  'footer.links.usage': 'Membership Terms',
  'footer.links.privacy': 'Privacy Policy',
};
